import { render, staticRenderFns } from "./completeness-check-modal-details-tab.vue?vue&type=template&id=357dfa24"
import script from "./completeness-check-modal-details-tab.vue?vue&type=script&lang=ts"
export * from "./completeness-check-modal-details-tab.vue?vue&type=script&lang=ts"
import style0 from "./completeness-check-modal-details-tab.vue?vue&type=style&index=0&id=357dfa24&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('357dfa24')) {
      api.createRecord('357dfa24', component.options)
    } else {
      api.reload('357dfa24', component.options)
    }
    module.hot.accept("./completeness-check-modal-details-tab.vue?vue&type=template&id=357dfa24", function () {
      api.rerender('357dfa24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/completeness-check/completeness-check-details-modal/completeness-check-modal-details-tab/completeness-check-modal-details-tab.vue"
export default component.exports